import React from "react";
import styled from "styled-components";
import { Spinner, Text, Button, Icon, COLOR_SYSTEM } from "components/atoms";
import { describeCaringNoteStatus, CaringNoteStatusKind } from "../caringnoteErrorCopy";

/**
 * 케어링노트 열람 공통 상태 화면 — 로딩 / 오류 4종 / 분석 미완(계획 §3-3 · T2).
 *
 * ⚠️ 어떤 상태에도 **로그인 링크·리다이렉트를 렌더하지 않는다.** 유일한 행동은 재시도이며,
 *    재시도 버튼은 일시적 오류(server·network)·분석 미완에서만 노출된다.
 */

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  padding: 32px 24px;
  text-align: center;
`;

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 420px;
`;

interface LoadingProps {
  variant: "loading";
}

interface StatusProps {
  variant: "status";
  kind: CaringNoteStatusKind;
  onRetry?: () => void;
}

type CaringNoteStatusProps = LoadingProps | StatusProps;

const CaringNoteStatus: React.FC<CaringNoteStatusProps> = (props) => {
  if (props.variant === "loading") {
    return (
      <Wrap role="status" aria-live="polite">
        <Spinner size="Large" />
        <Text textType="Body2" color={COLOR_SYSTEM.get("Gray")?.[500]}>
          불러오는 중입니다…
        </Text>
      </Wrap>
    );
  }

  const copy = describeCaringNoteStatus(props.kind);
  const showRetry = copy.canRetry && !!props.onRetry;

  return (
    <Wrap role="alert">
      <Icon
        name="Exclamation Mark Polygon"
        size={40}
        color={COLOR_SYSTEM.get("Gray")?.[400]}
      />
      <Copy>
        <Text element="div" textType="H4" color={COLOR_SYSTEM.get("Gray")?.[700]}>
          {copy.title}
        </Text>
        <Text element="div" textType="Body2" color={COLOR_SYSTEM.get("Gray")?.[500]}>
          {copy.message}
        </Text>
      </Copy>
      {showRetry && (
        <Button
          buttonType="button"
          type="Text"
          size="Medium"
          variant="Outlined"
          color="Secondary"
          onClick={props.onRetry}
        >
          다시 시도
        </Button>
      )}
    </Wrap>
  );
};

export default CaringNoteStatus;
